module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-ties-remnants.734f0aec.png";